"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACTION = void 0;
// import * as Extension from '../extension-types';
const __1 = require("..");
/** Actions possible */
var ACTION;
(function (ACTION) {
    ACTION["CREATE"] = "create";
    ACTION["APPLY_ACTION_TO_PN"] = "apply-action-to-pn";
})(ACTION || (exports.ACTION = ACTION = {}));
//# sourceMappingURL=pn-meta.js.map